export const normalizeDigitizationSettingToEmbroideryKind = (
  digitizationSetting: string | undefined
): 'LOGO_COLOR' | 'LOGO_BLACK_WHITE' | undefined => {
  if (digitizationSetting === 'COLOR' || digitizationSetting === 'LOGO_COLOR') {
    return 'LOGO_COLOR'
  }
  if (digitizationSetting === 'BLACK_WHITE' || digitizationSetting === 'LOGO_BLACK_WHITE') {
    return 'LOGO_BLACK_WHITE'
  }
  return undefined
}
